<button class="vote-button" disabled>
  <div class="vote-button-bg" />
  <div class="vote-button-bg lol" />
  <div class="vote-button-inner">Sender...</div>
</button>

<style>
  .vote-button {
    position: relative;
    padding: 0;
    background-color: transparent;
    z-index: 1;
    clip-path: inset(0);
    width: 100%;
  }
  .vote-button-inner {
    display: block;
    text-transform: uppercase;
    font-size: 1.5625rem;
    line-height: 2;
    font-weight: 890;
    letter-spacing: 0.2em;
    padding: 0.5635rem;
    background-color: var(--mgp-pink);
    margin: 0.5rem;
    box-shadow:
      0px 4px 4px rgba(0, 0, 0, 0.25),
      0px 6.25417px 15.8588px rgba(0, 0, 0, 0.92),
      0px 3.50603px 8.8903px rgba(255, 0, 88, 0.275),
      0px 1.86203px 4.72157px rgba(255, 0, 88, 0.222141),
      0px 0.774832px 21px var(--mgp-pink);
  }
  .vote-button-bg {
    position: absolute;
    top: 0;
    left: -2rem;
    right: -2rem;
    bottom: 0;
    z-index: -1;
    background-color: #ff004da6;
    animation: spin 4s linear infinite;
  }
  .vote-button-bg.lol {
    animation: spin 6s ease-in-out infinite;
  }

  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
</style>
